// extracted by mini-css-extract-plugin
export var banner = "_27-0";
export var icon = "_27-1";
export var message = "_27-2";